import { md5 } from "js-md5"

export default class FingerPrint {

    static get() {
        
        const canvas = document.createElement("canvas")
        const ctx = canvas.getContext("2d")
        const txt = "i9asdm..$#po((^@KbXrww!~cza"

        ctx.textBaseline = "top"
        ctx.font = "18px 'Arial'"
        ctx.textBaseline = "alphabetic"
        ctx.rotate(.05)
        ctx.fillStyle = "#f60"
        ctx.fillRect(125,1,62,20)
        ctx.fillStyle = "#069"
        ctx.fillText(txt, 2, 15)
        ctx.fillStyle = "rgba(102, 200, 0, 0.7)"
        ctx.fillText(navigator.userAgent, 4, 27)
        ctx.shadowBlur=10
        ctx.shadowColor="blue"
        ctx.fillRect(-20,10,234,5)

        const fpString = canvas.toDataURL()

        if (fpString.length === 0) {
            return null
        }

        return md5(fpString)
    }
}